export default "__VITE_ASSET__877290a1__"